import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';
import type {TabsStrategyData} from '../../types/tabsStrategyData';
import {TabsStrategyService} from '../../TabsStrategy';



@Service({id: 'tabsFallbackStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<TabsStrategyService> {

  build(details:TabsStrategyData): TabsStrategyService {
      return new TabsStrategyFallback(details);
  }
}

export class TabsStrategyFallback extends TabsStrategyService {
  details;

  constructor(details:TabsStrategyData) {
      super();
      this.details = details;
  }

  makeTabs() {
      return 'search-tabs-nav-header-v2';
  }
  getTabProps(params: Record<string, string>): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }


}
